/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const welcome = require('appComp/page/welcome/welcome');
const pageLayout = require('appComp/layout/page-layout/page-layout');

const configPushRoute = require('./configPush');
const challengeRoute = require('./challenge');

const userRouter = require('./user');
const userdata = require('./userdata');
const recycled = require('./recycled');
const chargeRouter = require('./charge');

const serverRouter = require('./server');
const usedCarRouter = require('./usedCar');
const previewRouter = require('./preview');
const community = require('./community');

const login = require('appComp/page/login/login');
const defaultPage = require('appComp/page/default/default');
const defaultPage403 = require('appComp/page/default/default403');

// const pageLayout = require('appComp/layout/page-layout/page-layout');

// const chargeRouter = require('./charge');
// const siteLists = require('appComp/page/charge/site-lists/site-lists');

module.exports = {
    "*": {
        "title": "404",
        "component": defaultPage
    },
    "403": {
        "title": "403",
        "component": defaultPage403
    },
    "/": {
        "title": "欢迎您使用猛犸电动App后台系统",
        "component": login
    },
    "/login": {
        "title": "欢迎您使用猛犸电动App后台系统",
        "component": login
    },
    "/preview": previewRouter,
    "/page": {
        "component": pageLayout,
        "subRoutes": {
            "/usedCar": usedCarRouter,
            "/configPush": configPushRoute,
            "/server": serverRouter,
            "/user": userRouter,
            "/userdata": userdata,
            "/recycled": recycled,
            "/charge": chargeRouter,
            "/community": community,
            "/challenge": challengeRoute
        }
    }
}



// WEBPACK FOOTER //
// ./src/appBackend/router/router.js